export default __webpack_public_path__ + "static/media/globe.63cc703e.svg";